import { render } from "./DefaultTopics.vue?vue&type=template&id=2c43387a&scoped=true"
import script from "./DefaultTopics.vue?vue&type=script&lang=js"
export * from "./DefaultTopics.vue?vue&type=script&lang=js"

import "./DefaultTopics.vue?vue&type=style&index=0&id=2c43387a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c43387a"]])

export default __exports__